import { Button, Space } from 'antd';
import { FaFileCsv } from '@react-icons/all-files/fa/FaFileCsv';
import React from 'react';

const ButtonExport = ({ disabled, loading, title, execute }) => {
  return (
    <Button type="primary" disabled={disabled} loading={loading} onClick={() => execute()}>
      <Space>
        <Space style={{ paddingBottom: '5px' }}>Exportar</Space>
        <FaFileCsv style={{ fontSize: '20px', borderRadius: '6px' }} title={title} />
      </Space>
    </Button>
  );
};
export default ButtonExport;